import {
  Button,
  Copy,
  Flex,
  Stack,
  Typography,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { currencyFormatter } from 'src/utilities/currency-utils';

export interface IAllowanceAmountInfo {
  amount: string;
  onEdit: () => void;
}

export function AllowanceAmountInfo({
  amount,
  onEdit,
}: IAllowanceAmountInfo): JSX.Element {
  return (
    <Flex alignItems="center">
      <Stack x="sm">
        <Copy variant="body">
          Allowance amount for all people:{' '}
          <Typography weight="bold">
            {currencyFormatter(Number(amount))}
          </Typography>
        </Copy>
      </Stack>
      <Button variant="secondary" onClick={onEdit} buttonSize="small">
        Edit
      </Button>
    </Flex>
  );
}
